function DateInput({ label, className, ...props }) {
  return (
    <div>
      {label && <label className="etiqueta">{label}</label>}
      <input
        type="date"
        lang="es-CO"
        className={className}
        {...props}
      />
    </div>
  );
}

export default DateInput;
